import tw, { styled } from 'twin.macro';

const ThreeQuartersLayout = styled.div`
  ${tw`w-3/4 flex-none`}
`;

export default ThreeQuartersLayout;
